import useContextSafe from '../../../hooks/useContextSafe';
import LobbyFiltersContext from '../components/LobbyFiltersContext';
import LobbyTableMobile from '../components/LobbyTableMobile';
import InputSearch from '@/components/InputSearch/InputSearch';
import MobileFilters from '../components/MobileFilters';
import { twMerge } from 'tailwind-merge';
import { useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';
import useGetUserTables from '@/services/table/queries/useGetUserTables';
import { useMemo } from 'react';
import TableTabs from '@/pages/table/components/TableTab/TableTabs';

const LobbyMobileDisplay = () => {
  const {
    filters,
    handleCategory,
    handleEmptyTables,
    handleNameSearch,
    handleFullTables,
    handleRangeChange,
    handleTableSize,
    handleStakes,
    handleGames,
    handleResetFilters,
    handleGameType,
    handleSaveFilters,
    handleCloseWithoutSaving,
  } = useContextSafe(LobbyFiltersContext);

  const userId = useSelector((state: ReducerState) => state.auth.id);
  const { data: userTablesData } = useGetUserTables({
    userId,
  });

  const isPlaying = useMemo(() => !!userTablesData?.data?.length, [userTablesData]);

  return (
    <div className="w-full grow">
      <div className="peer mt-5 flex items-center justify-between gap-4 align-middle">
        <div>
          <MobileFilters
            filters={filters}
            onRangeChange={handleRangeChange}
            onTableSizeChange={handleTableSize}
            onEmptyTables={handleEmptyTables}
            onFullTables={handleFullTables}
            onStakes={handleStakes}
            onGameType={handleGameType}
            onGames={handleGames}
            onResetFilters={handleResetFilters}
            onSaveFilters={handleSaveFilters}
            onCloseWithoutSaving={handleCloseWithoutSaving}
            onCategoryChange={handleCategory}
          >
            {isPlaying && userId && (
              <div
                className={twMerge(
                  'max-w-full grow overflow-hidden transition-all duration-500 ease-in-out has-[~button[data-open=true]]:max-w-0',
                )}
              >
                <TableTabs
                  tables={userTablesData?.data}
                  userId={userId}
                  className="max-w-[calc(100vw-44px-16px-32px)]"
                />
              </div>
            )}
            <div
              className={twMerge(
                'max-w-0 grow overflow-hidden transition-all duration-500 ease-in-out has-[+button[data-open=true]]:max-w-full',
                !isPlaying && '!max-w-full',
              )}
            >
              <InputSearch
                placeholder={'Search for a table...'}
                fullWidth
                value={filters?.name}
                handleNameSearch={handleNameSearch}
              />
            </div>
          </MobileFilters>
        </div>
      </div>
      <div
        className={twMerge(
          'max-h-full grow overflow-hidden py-4 transition-all duration-500 ease-in-out peer-has-[button[data-open=true]]:max-h-0 peer-has-[button[data-open=true]]:py-0',
        )}
      >
        <LobbyTableMobile />
      </div>
    </div>
  );
};

export default LobbyMobileDisplay;
